import React from 'react';
import BoardCard from '../BoardCard/BoardCard';
import './BoardList.css';
import { useI18n } from '../../../../i18n';

const BoardList = ({ data, onCardChange, onCardDelete }) => {
	const { t } = useI18n();
	const lanes = (data && data.lanes) || [];

	return (
		<div className="board-list">
			{lanes.map((lane) => (
				<section key={lane.id} className="board-list-lane">
					<header className="board-list-lane-head">
						<h3>{lane.title}</h3>
						<span>{(lane.cards || []).length} {(lane.cards || []).length === 1 ? t('common.card') : t('common.cards')}</span>
					</header>
					{(lane.cards || []).length === 0 ? (
						<p className="board-list-empty">{t('board.noCards')}</p>
					) : (
						<div className="board-list-cards">
							{(lane.cards || []).map((card) => (
								<BoardCard
									key={card.id}
									{...card}
									onChange={(next) => onCardChange(lane.id, card.id, next)}
									onDelete={() => onCardDelete(lane.id, card.id)}
								/>
							))}
						</div>
					)}
				</section>
			))}
		</div>
	);
};

export default BoardList;
